import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=2fdcd9e8&scoped=true&"
import script from "./Spacer.vue?vue&type=script&lang=js&"
export * from "./Spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdcd9e8",
  null
  
)

export default component.exports